import { useSearchParams } from 'next/navigation';
import React, { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';

import Icon from '../../atoms/icons/Icon';
import css from './style.module.scss';
import { siteUrl } from 'src/utils/rsv-dashboard-routes';

const AlertBand: FC = () => {
  const intl = useIntl();
  const searchParams = useSearchParams();

  const siteUrlWithDashboardContext = useMemo(() => {
    if (!searchParams) {
      return siteUrl;
    }

    const dashboardContext = {
      businessEntity: searchParams.get('business_entity'),
      shop: searchParams.get('shop'),
      version: searchParams.get('v'),
    };

    if (
      !!dashboardContext.businessEntity &&
      !!dashboardContext.shop &&
      !!dashboardContext.version &&
      dashboardContext.version === '2506'
    ) {
      return `${siteUrl}?v=${dashboardContext.version}&business_entity=${dashboardContext.businessEntity}&shop=${dashboardContext.shop}`;
    }

    return siteUrl;
  }, [searchParams]);

  return (
    <div className={css.container}>
      <div>
        <Icon name="warning" className={css.warning_icon} />
      </div>
      <div className={css.text}>
        <p className={css.paragraph}>
          {intl.formatMessage({
            id: 'alertBand.thisSiteIsUnpublished',
          })}
          {intl.formatMessage({
            id: 'alertBand.toAcceptReservation',
          })}
          <a href={siteUrlWithDashboardContext} className={css.link}>
            {intl.formatMessage({
              id: 'alertBand.siteSetting',
            })}
          </a>
          {intl.formatMessage({
            id: 'alertBand.canPublishSite',
          })}
        </p>
      </div>
    </div>
  );
};

export default AlertBand;
